import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import FeatureSection from "./components/FeatureSection";
//  import PortfolioSection from "./components/PortfolioSection";
// import TechnologiesSection from "./components/TechnologiesSection";
import LetsBuild from "./components/LetsBuild";
import FooterSection from "./components/FooterSection";
import ContactSection from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import LeadManagementPage from "./components/LeadManagementPage";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <FeatureSection />
      {/* <PortfolioSection /> */}
      {/* <TechnologiesSection /> */}
      <LetsBuild />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <ScrollToTop />

        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/about-us" element={<AboutUs />} />

          <Route path="/contactus" element={<ContactSection />} />

          <Route path="/services" element={<Services />} />

          <Route path="/portfolio" element={<Portfolio />} />

          <Route
            path="/products/lead-management"
            element={<LeadManagementPage />}
          />
        </Routes>

        <FooterSection />
      </div>
    </BrowserRouter>
  );
}

export default App;
